import React from 'react';
import { NavLink } from "react-router-dom";

const Navigation = () => {
	return(
		<div className = "navigationBar">
			<div className = "container">
				<div>
					<NavLink className = "navigationItem" to = "/">Home</NavLink>
				</div>
				<NavLink className = "navigationItem" to = "/Cart">
					<i className ="cart icon"></i>
				</NavLink>
			</div>
		</div>

		)
}

export default Navigation;